import { ThemeEnum } from '../enums/appEnum';

export const prefixCls = 'ciic-ygj';

export const darkMode = ThemeEnum.LIGHT;

// app theme preset color 应用主题预设颜色
export const APP_PRESET_COLOR_LIST: string[] = [
  '#0042ff',
  '#6076E3',
  '#E56281',
  '#34CEA2',
  '#FFAA32',
  '#43D2E9',
];
export const APP_PRESET_COLOR_IMAGE_LIST = [
  { img: '0042ff', title: '蓝色(默认)' },
  { img: '6076E3', title: '紫色'},
  { img: 'E56281', title: '粉红色'},
  { img: '34CEA2', title: '绿色'},
  { img: 'FFAA32', title: '橙色'},
  { img: '43D2E9', title: '青色'},
];

// header preset color 顶栏主题颜色
export const HEADER_PRESET_BG_COLOR_LIST: string[] = [
  '#0042ff',
  '#0960bd',
  '#0084f4',
  '#009688',
  '#536dfe',
  '#ff5c93',
  '#ee4f12',
  '#0096c7',
  '#9c27b0',
  '#ff9800',
];

// sider preset color 侧边栏预设颜色
export const SIDE_BAR_BG_COLOR_LIST: string[] = [
  '#ffffff',
  '#0042ff',
  '#212121',
  '#273352',
  '#191b24',
  '#191a23',
  '#304156',
  '#001628',
  '#28333E',
  '#344058',
  '#383f45',
];

// echarts图表预设颜色

export const ECHARTS_COLOR_LIST = [
  '#6099FF',
  '#8DE4C1',
  '#FF6767',
  // '#F7DB8C',
  // '#ABA3FF',
  // '#B2BED2',
];
